import React from "react";
import logo from "../assets/smartup360-logo.png";

export default function Logo({ size = "default" }) {
  return (
    <span className={`logo logo--${size}`}>
      <img src={logo} alt="SmartUp360 logo" className="logo__img" />
    </span>
  );
}
